import React, { FC } from 'react';

import { CarouselStackedCards } from '@bumble/ui-kit';
import lexemes from 'components/lexemes/page-index';

import { onClickDownloadNowCta } from 'containers/events';

export const LandingStackedCardsContainer: FC = () => {
  return (
    <CarouselStackedCards
      title={lexemes.lxPageIndexCarouselStackedTitle}
      description={lexemes.lxPageIndexCarouselStackedDescription}
      cta={{
        text: lexemes.lxPageIndexCarouselStackedCta,
        href: 'https://bumble.onelink.me/3396940749/yuhjm82c',
        onClick: onClickDownloadNowCta,
      }}
      cards={[
        {
          imageSrc: '/project-love/assets/card1.jpg',
          imageAlt: lexemes.lxPageIndexCarouselStackedCard1Alt,
          badgeText: lexemes.lxPageIndexCarouselStackedCard1Badge,
        },
        {
          imageSrc: '/project-love/assets/card2.jpg',
          imageAlt: lexemes.lxPageIndexCarouselStackedCard2Alt,
          badgeText: lexemes.lxPageIndexCarouselStackedCard2Badge,
        },
        {
          imageSrc: '/project-love/assets/card3.jpg',
          imageAlt: lexemes.lxPageIndexCarouselStackedCard3Alt,
          badgeText: lexemes.lxPageIndexCarouselStackedCard3Badge,
        },
      ]}
    />
  );
};
